module.exports = __webpack_public_path__ + "static/img/06.6df986c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/news/gallery/3/06.jpg
// module id = 769
// module chunks = 0